import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx, search, nullsafe, assertUnreachable } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

import { ListGuiasEntregaMem } from "./listmem";
import * as logic from "../logic";

export interface Props {
    value: models.EntregaZERealizadaDTO;
    onChange: (value: models.EntregaZERealizadaDTO) => PromiseLike<void> | void;
    nuevo: boolean;
}

/**Listado de las guias de entrega */
export class ListGuiasEntrega extends React.PureComponent<Props> {
    value = (props: Props) => props.value;
    nuevo = (props: Props) => props.nuevo;

    items = createSelectorRx(this.value, (value) => logic.obtenerGuiasDeState(value));

    onSeleccionar = (entity: models.GuiaEntregaZESelect, value: boolean | null) => {
        const nextValue = logic.onSeleccionarGuiaEntregaChange(this.props.value, entity.Guia.IdRegistro, value);
        this.props.onChange(nextValue);
    }
    onMotivoChange = (entity: models.GuiaEntregaZESelect, value: string) => {
        const nextValue = logic.onMotivoGuiaEntregaChange(this.props.value, entity.Guia.IdRegistro, value);
        this.props.onChange(nextValue);
    }

    render() {
        const items = this.items(this.props);
        const nuevo = this.nuevo(this.props);
        return <ListGuiasEntregaMem nuevo={nuevo} items={items} onSeleccionar={this.onSeleccionar} onMotivoChange={this.onMotivoChange} />;
    }
}



// WEBPACK FOOTER //
// ./app/features/general/operativa/items/viajeappZE/entrega/list/list.tsx